var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefrigeratedBoxcar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 25,
    viewBox: "0 0 90 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wgy4kf4joa)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.06 20.352H22.827v.328H33.06v-.328z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.457 20.595v-1.278h-.39v1.278h.39zM28.84 20.595v-1.278h-.389v1.278h.39zM31.226 20.595v-1.278h-.39v1.278h.39z",
    fill: "#666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24 9.437v.369h.182l2.481.001h.621l-.44-.371-.62.001H1.24zM1.24 6.305v.369h.182l2.481.001h.621l-.44-.371-.62.001H1.24zM1.24 3.173v.369h.182l2.481.002h.621l-.44-.372-.62.001H1.24zM10.3.149h-.437v.154l-.002 2.092v.524l.441-.372-.002-.522V.149zM5.915.149h-.437v.154l-.001 2.092v.524l.44-.372-.002-.522V.149z",
    fill: "orange"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.994 1.727v10.822c0 .102.099.184.219.184.121 0 .218-.084.218-.184V1.724H.998l-.004.003z",
    fill: "orange"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m.994 1.727.31.261.129-.109L3.189.4l.438-.37h-.623L2.57.4.994 1.727z",
    fill: "orange"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57.4h9.332c.121 0 .218-.083.218-.184 0-.103-.098-.184-.218-.184H3.004l-.437.37L2.57.4z",
    fill: "orange"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.332 17.71h-.416v1.968h.416V17.71zM44.306 17.71h-.416v1.968h.416V17.71z",
    fill: "#666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 20.451H54.9v.2h11.57v-.2zM41.797 19.569h-15.39v.22h15.39v-.22z",
    fill: "gray"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.706 19.19h2.81c.121 0 .22.084.22.186v1.106c0 .102-.099.186-.22.186h-2.81c-.122 0-.22-.084-.22-.186v-1.106c0-.102.098-.186.22-.186z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.738 19.376v.25h-3.253v-.25c0-.102.1-.186.22-.186h2.81c.122 0 .221.084.221.186h.002z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.738 20.232v.25c0 .102-.099.186-.22.186h-2.81c-.122 0-.22-.084-.22-.186v-.25h3.252-.002z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.298 18.036H21.313v1.885h11.985v-1.885zM68.159 18.036H56.174v1.885h11.985v-1.885z",
    fill: "#1A1A1A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M85.34 18.49c.803.19 1.62.377 2.378.697.76.314 1.442.785 1.921 1.38l-.158.09a4.196 4.196 0 0 0-.819-.765 5.37 5.37 0 0 0-1.026-.567c-.737-.31-1.538-.51-2.344-.684l.047-.15z",
    fill: "orange"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m90.002 20.897-.078-.095-.1.059.078.095.1-.06zM89.813 21.005l-.079-.095-.1.059.079.094.1-.058z",
    fill: "orange"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m89.757 20.498.247.3-.388.228-.248-.3c-.04-.049-.026-.117.033-.152l.178-.104c.057-.034.138-.023.18.027l-.002.001zM5.455 18.49c-.804.19-1.62.377-2.379.697-.76.314-1.442.785-1.92 1.38l.157.09a4.25 4.25 0 0 1 .819-.765 5.37 5.37 0 0 1 1.026-.567c.737-.31 1.539-.51 2.344-.684l-.047-.15z",
    fill: "orange"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m.894 20.959.078-.095-.1-.059-.078.095.1.059zM1.077 21.063l.078-.094-.1-.059-.078.095.1.058z",
    fill: "orange"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m1.434 20.726-.247.3-.388-.228.247-.3a.145.145 0 0 1 .18-.027l.178.105c.057.033.073.101.032.151h-.002z",
    fill: "orange"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.868 18.584h-1.155v1.967h1.155v-1.967zM39.646 18.584h-1.155v1.967h1.155v-1.967z",
    fill: "#666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3 19.013h1.757c.23 0 .416-.157.416-.351v-1.098c0-.193-.187-.35-.416-.35h-1.758c-.23 0-.416.157-.416.35v1.098c0 .194.186.35.416.35z",
    fill: "#333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.9 17.46a.502.502 0 0 1 .121-.016h1.76c.23 0 .415.157.415.351v1.098a.299.299 0 0 1-.017.1c.17-.044.293-.176.293-.334V17.56c0-.194-.186-.35-.416-.35h-1.758c-.186 0-.347.104-.399.248v.001z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m85.235 18.378 3.485.174c.177.008.327-.111.327-.26v-.436c0-.15-.15-.269-.327-.26l-3.485.174v.61-.002z",
    fill: "orange"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m87.975 18.008.69-.005v-.262l-.69.024v.243zM87.152 18.013l.563-.003v-.236l-.563.02v.22zM86.466 18.02l.47-.005v-.213l-.47.016v.202zM85.889 18.023l.397-.003v-.196l-.397.013v.186zM87.975 18.382l.69.024v-.261l-.69-.005v.242zM87.152 18.353l.563.019v-.235l-.563-.004v.22zM86.466 18.329l.47.017v-.214l-.47-.004v.2zM85.889 18.31l.397.014v-.197l-.397-.003v.185zM88.923 19.183h-.222c-.108 0-.194-.074-.194-.164v-.118h.61v.118c0 .091-.087.164-.194.164zM87.93 19.183h-.223c-.108 0-.194-.074-.194-.164v-.118h.61v.118c0 .091-.087.164-.194.164zM.88 18.827l-.749-.292c-.08-.03-.131-.1-.131-.173v-.498c0-.075.051-.143.131-.173l.749-.292v1.428z",
    fill: "#333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M.88 17.4v.092l-.627.244c-.092.035-.149.112-.149.195v.561c0 .011.002.022.004.034A.188.188 0 0 1 0 18.364v-.498c0-.076.051-.141.131-.173l.749-.29v-.004z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2.244 17.486v1.256c0 .149-.145.27-.322.27H1.01a.355.355 0 0 1-.218-.072.251.251 0 0 1-.106-.2v-1.256c0-.15.144-.272.323-.272h.91c.152 0 .279.09.311.21a.23.23 0 0 1 .01.064h.003z",
    fill: "#333"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.234 17.422H1.09c-.165 0-.298.189-.298.42v1.099a.251.251 0 0 1-.106-.2v-1.257c0-.15.144-.272.323-.272h.91c.152 0 .279.09.311.21h.004z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m4.864 18.378-3.484.173c-.177.008-.327-.11-.327-.26v-.435c0-.15.15-.27.327-.26l3.484.173v.61-.001z",
    fill: "orange"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m2.124 18.008-.69-.005v-.263l.69.024v.244zM2.949 18.013l-.564-.004v-.235l.564.02v.219zM3.632 18.02l-.469-.006v-.213l.47.016v.202zM4.21 18.022l-.397-.003v-.195l.398.012v.186zM2.124 18.381l-.69.024v-.261l.69-.005v.242zM2.949 18.352l-.564.02v-.236l.564-.003v.22zM3.632 18.328l-.469.018v-.215l.47-.003v.2zM4.21 18.309l-.397.014v-.197l.398-.003v.186z",
    fill: "#333"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 16.643H3.072v2.163H86.4v-2.163z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.82 18.316v-1.188H3.65v1.188h82.17z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M57.126 18.805h-2.812c-.15 0-.272.102-.272.229v1.762c0 .127.122.23.272.23h2.812c.15 0 .271-.104.271-.23v-1.762c0-.127-.121-.23-.271-.23z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.905 18.977h-2.371c-.127 0-.23.087-.23.194v1.486c0 .107.103.193.23.193h2.37c.128 0 .23-.087.23-.194v-1.485c0-.107-.102-.194-.23-.194z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.992.726h-5.626v.676h5.626V.726z",
    fill: "lightblue"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.992.726h-5.626v.676h5.626V.726z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.317.501H14.04v.332h6.276V.501z",
    fill: "lightblue"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.101.264h-.256v.569h.256V.264zM19.514.264h-.256v.569h.256V.264zM47.549.726h-5.626v.676h5.626V.726z",
    fill: "lightblue"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.549.726h-5.626v.676h5.626V.726z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.873.501h-6.275v.332h6.275V.501z",
    fill: "lightblue"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.656.264h-.257v.569h.257V.264zM47.07.264h-.255v.569h.256V.264zM75.105.726H69.48v.676h5.626V.726z",
    fill: "lightblue"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.105.726H69.48v.676h5.626V.726z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M75.43.501h-6.276v.332h6.276V.501z",
    fill: "lightblue"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M70.213.264h-.257v.569h.257V.264zM74.628.264h-.257v.569h.257V.264zM86.825 2.477H2.648v15.17h84.177V2.476z",
    fill: "lightblue"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M85.94 3.223H3.532v13.678H85.94V3.223z",
    fill: "lightblue"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.942 3.223H3.534V16.9h82.408V3.223z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.86 3.223h-.885V16.9h.885V3.223zM3.869 3.223h-.335V16.9h.335V3.223zM19.538 3.223h-.886V16.9h.886V3.223zM28.216 3.223h-.885V16.9h.885V3.223zM36.895 3.223h-.885V16.9h.885V3.223zM45.574 3.223h-.886V16.9h.886V3.223zM54.25 3.223h-.885V16.9h.886V3.223zM62.932 3.223h-.885V16.9h.885V3.223zM71.609 3.223h-.885V16.9h.885V3.223zM80.286 3.223H79.4V16.9h.886V3.223z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.466 2.912h-.885v14.61h.885V2.913zM19.145 2.912h-.885v14.61h.885V2.913zM27.822 2.912h-.886v14.61h.886V2.913zM36.502 2.912h-.886v14.61h.886V2.913zM45.18 2.912h-.885v14.61h.885V2.913zM53.857 2.912h-.885v14.61h.885V2.913zM62.536 2.912h-.886v14.61h.886V2.913zM71.215 2.912h-.885v14.61h.885V2.913zM79.894 2.912h-.885v14.61h.885V2.913z",
    fill: "lightblue"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.326 4.676H19.142v.583h51.184v-.583z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M70.421 7.453H19.055v.126H70.42v-.126zM70.421 4.45H19.055v.583H70.42V4.45z",
    fill: "lightblue"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.33 7.603H19.144v.127H70.33v-.127z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.58 6.715h-3.724v.226h3.723v-.226zM33.58 8.87h-3.724v.226h3.723V8.87zM33.58 11.026h-3.724v.226h3.723v-.226zM33.58 13.181h-3.724v.226h3.723v-.226zM33.58 15.336h-3.724v.226h3.723v-.226z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M70.421 16.342H19.055v.583H70.42v-.583z",
    fill: "lightblue"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.614 6.715h-3.723v.226h3.724v-.226zM59.614 8.87h-3.723v.226h3.724V8.87zM59.614 11.026h-3.723v.226h3.724v-.226zM59.614 13.181h-3.723v.226h3.724v-.226zM59.614 15.336h-3.723v.226h3.724v-.226z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M56.738 4.978h-24v11.656h24V4.978z",
    fill: "lightblue"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.68 6.893v-.266h-3.757V5.538h-.669v1.09H36.7v-1.09h-.665v1.09h-2.636v.265h2.636v1.109h-2.636v.266h2.636v1.109h-2.636v.265h2.636v1.11h-2.636v.265h2.636v1.109h-2.636v.266h2.636V13.5h-2.636v.266h2.636v1.109h-2.636v.266h2.636v.934h.665v-.934h3.554v.934h.67v-.934h3.755v-.266h-3.756v-1.109h3.756V13.5h-3.756v-1.108h3.756v-.266h-3.756v-1.109h3.756v-.266h-3.756V9.642h3.756v-.265h-3.756v-1.11h3.756v-.265h-3.756V6.893h3.756zm-4.424 7.982h-3.554v-1.109h3.554v1.109zm0-1.375h-3.554v-1.108h3.554V13.5zm0-1.374h-3.554v-1.109h3.554v1.109zm0-1.375h-3.554V9.642h3.554v1.11zm0-1.374h-3.554v-1.11h3.554v1.11zm0-1.375h-3.554V6.893h3.554v1.109zm15.817-1.109v-.266h-2.489V5.538h-.665v1.09h-3.554v-1.09h-.67v1.09H44.94v.265h3.756v1.109H44.94v.266h3.756v1.109H44.94v.265h3.756v1.11H44.94v.265h3.756v1.109H44.94v.266h3.756V13.5H44.94v.266h3.756v1.109H44.94v.266h3.756v.934h.669v-.934h3.554v.934h.665v-.934h2.49v-.266h-2.49v-1.109h2.49V13.5h-2.49v-1.108h2.49v-.266h-2.49v-1.109h2.49v-.266h-2.49V9.642h2.49v-.265h-2.49v-1.11h2.49v-.265h-2.49V6.893h2.49zm-3.154 7.982h-3.554v-1.109h3.554v1.109zm0-1.375h-3.554v-1.108h3.554V13.5zm0-1.374h-3.554v-1.109h3.554v1.109zm0-1.375h-3.554V9.642h3.554v1.11zm0-1.374h-3.554v-1.11h3.554v1.11zm0-1.375h-3.554V6.893h3.554v1.109z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.073 5.537H33.401v10.538h22.672V5.537z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M45.551 5.173h-1.626v11.19h1.626V5.173z",
    fill: "lightblue"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.114 5.173h-.667v11.19h.667V5.173zM36.63 5.173h-.667v11.19h.667V5.173zM40.85 5.173h-.667v11.19h.666V5.173zM49.293 5.173h-.667v11.19h.667V5.173zM53.513 5.173h-.667v11.19h.667V5.173z",
    fill: "lightblue"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.87 5.524h-.263v10.554h.263V5.524z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M46.413 9.819H45.38v1.973h1.032V9.82z",
    fill: "lightblue"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M46.048 10.47h-2.765v.67h2.765v-.67zM56.338 5.173h-23.2v.266h23.2v-.266zM44.608 6.547H33.136v.266h11.472v-.266zM56.336 6.547H44.868v.266h11.468v-.266zM44.608 7.922H33.136v.266h11.472v-.266zM56.336 7.922H44.868v.266h11.468v-.266zM44.608 9.296H33.136v.266h11.472v-.266zM56.336 9.296H44.868v.266h11.468v-.266z",
    fill: "lightblue"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M44.608 10.67H33.136v.267h11.472v-.266zM56.336 10.67H44.868v.267h11.468v-.266zM44.608 12.045H33.136v.266h11.472v-.266zM56.336 12.045H44.868v.266h11.468v-.266zM44.608 13.422H33.136v.266h11.472v-.266zM56.336 13.422H44.868v.266h11.468v-.266zM44.608 14.796H33.136v.266h11.472v-.266zM56.336 14.796H44.868v.266h11.468v-.266zM56.338 16.17h-23.2v.267h23.2v-.266z",
    fill: "lightblue"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.42 4.561H4.694v.226H8.42V4.56zM8.42 6.716H4.694v.226H8.42v-.226zM8.42 8.87H4.694v.226H8.42v-.225zM8.42 11.027H4.694v.226H8.42v-.226zM8.42 13.182H4.694v.226H8.42v-.226zM8.42 15.336H4.694v.226H8.42v-.226zM15.742 4.561h-2.748c-.27 0-.488.184-.488.412v1.64c0 .228.219.412.488.412h2.748c.27 0 .488-.184.488-.412v-1.64c0-.228-.219-.412-.489-.412zM16.23 8.87h-3.724v.226h3.724v-.225zM16.23 11.027h-3.724v.226h3.724v-.226zM16.23 13.182h-3.724v.226h3.724v-.226zM16.23 15.336h-3.724v.226h3.724v-.226zM24.903 6.715h-3.724v.226h3.724v-.226zM24.903 8.87h-3.724v.226h3.724V8.87zM24.903 11.026h-3.724v.226h3.724v-.226zM24.903 13.181h-3.724v.226h3.724v-.226zM24.903 15.336h-3.724v.226h3.724v-.226zM84.78 4.561h-3.723v.226h3.724V4.56zM84.78 6.716h-3.723v.226h3.724v-.226zM84.78 8.87h-3.723v.226h3.724v-.225zM84.78 11.027h-3.723v.226h3.724v-.226zM84.78 13.182h-3.723v.226h3.724v-.226zM84.78 15.336h-3.723v.226h3.724v-.226zM76.484 4.561h-2.748c-.27 0-.488.184-.488.412v1.64c0 .228.219.412.488.412h2.748c.27 0 .488-.184.488-.412v-1.64c0-.228-.219-.412-.488-.412zM76.972 8.87h-3.724v.226h3.724v-.225zM76.972 11.027h-3.724v.226h3.724v-.226zM76.972 13.182h-3.724v.226h3.724v-.226zM76.972 15.336h-3.724v.226h3.724v-.226zM68.293 6.715H64.57v.226h3.724v-.226zM68.293 8.87H64.57v.226h3.724V8.87zM68.293 11.026H64.57v.226h3.724v-.226zM68.293 13.181H64.57v.226h3.724v-.226zM68.293 15.336H64.57v.226h3.724v-.226z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20.291 4.792h-1.463v2.723h1.463V4.792zM70.647 4.792h-1.463v2.723h1.463V4.792z",
    fill: "lightblue"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.825 2.743v1.642H2.648V2.743c.078-.095.168-.185.266-.266a2.52 2.52 0 0 1 1.612-.56H84.95a2.52 2.52 0 0 1 1.611.56c.097.081.186.171.266.266h-.002z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M87.236 3.089v.538h-85v-.538c0-1.066 1.024-1.93 2.288-1.93H84.95c1.263 0 2.286.864 2.286 1.93z",
    fill: "lightblue"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.09 2.413a2.626 2.626 0 0 0-1.399-.388H3.783a2.65 2.65 0 0 0-1.402.39c.325-.735 1.16-1.257 2.143-1.257H84.95c.98 0 1.816.52 2.14 1.253v.002z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.522 1.16H7.24v2.467h.283V1.16zM14.993 1.16h-.283v2.467h.283V1.16zM22.466 1.16h-.285v2.467h.285V1.16zM29.937 1.16h-.285v2.467h.285V1.16zM37.406 1.16h-.283v2.467h.283V1.16zM44.879 1.16h-.283v2.467h.283V1.16zM52.351 1.16h-.285v2.467h.285V1.16zM59.822 1.16h-.285v2.467h.285V1.16zM67.293 1.16h-.283v2.467h.283V1.16zM74.764 1.16h-.283v2.467h.284V1.16zM82.237 1.16h-.283v2.467h.283V1.16z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.786 19.921H8.579l-4.14-1.337h17.487l-4.14 1.337z",
    fill: "#666"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M17.786 19.921H8.579l-4.14-1.337h17.487l-4.14 1.337z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.786 19.655H8.579l-4.14-1.338h17.487l-4.14 1.338z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16.056 17.01H10.31v2.693h5.746V17.01z",
    fill: "#1A1A1A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.42 19.434H8.945a.777.777 0 0 0-.777.777v.937c0 .43.348.777.777.777h8.473c.43 0 .777-.348.777-.777v-.937a.777.777 0 0 0-.777-.777z",
    fill: "#333"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31 23.833a2.59 2.59 0 1 0-1.983-4.787 2.59 2.59 0 0 0 1.983 4.787z",
    fill: "gray"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M10.64 21.986a2.387 2.387 0 1 0-4.646-1.097 2.387 2.387 0 0 0 4.646 1.097z",
    fill: "orange"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M9.935 21.82a1.663 1.663 0 1 0-3.237-.765 1.663 1.663 0 0 0 3.237.764z",
    fill: "#333"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.837 21.44a.52.52 0 1 1-1.041 0 .52.52 0 0 1 1.041 0z",
    fill: "orange"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M19.881 23.27a2.59 2.59 0 1 0-3.664-3.663 2.59 2.59 0 0 0 3.664 3.664z",
    fill: "gray"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M19.738 23.127a2.387 2.387 0 1 0-3.376-3.376 2.387 2.387 0 0 0 3.376 3.376z",
    fill: "orange"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M19.69 21.707a1.663 1.663 0 1 0-3.283-.533 1.663 1.663 0 0 0 3.283.533z",
    fill: "#333"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M18.57 21.44a.52.52 0 1 1-1.042 0 .52.52 0 0 1 1.042 0zM13.103 20.925h-1.58v.24h1.58v-.24zM13.103 21.358h-1.58v.24h1.58v-.24zM13.103 20.495h-1.58v.24h1.58v-.24z",
    fill: "orange"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m13.103 20.735-1.58.445v-.24l1.58-.445v.24z",
    fill: "gray"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M13.103 21.79h-1.58v.24h1.58v-.24zM13.103 22.23h-1.58v.24h1.58v-.24z",
    fill: "orange"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m13.103 21.167-1.58.444v-.24l1.58-.446v.242zM13.103 21.598l-1.58.446v-.242l1.58-.444v.24zM13.103 22.03l-1.58.445v-.24l1.58-.446v.24z",
    fill: "gray"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M13.103 20.062h-1.58v.24h1.58v-.24z",
    fill: "orange"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m13.103 20.304-1.58.444v-.24l1.58-.446v.242z",
    fill: "gray"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M14.841 20.925h-1.58v.24h1.58v-.24zM14.841 21.358h-1.58v.24h1.58v-.24zM14.841 20.495h-1.58v.24h1.58v-.24z",
    fill: "orange"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m14.843 20.735-1.581.445v-.24l1.58-.445v.24z",
    fill: "gray"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M14.841 21.79h-1.58v.24h1.58v-.24zM14.841 22.23h-1.58v.24h1.58v-.24z",
    fill: "orange"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m14.843 21.167-1.581.444v-.24l1.58-.446v.242zM14.843 21.598l-1.581.446v-.242l1.58-.444v.24zM14.843 22.03l-1.581.445v-.24l1.58-.446v.24z",
    fill: "gray"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M14.841 20.062h-1.58v.24h1.58v-.24z",
    fill: "orange"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m14.843 20.304-1.581.444v-.24l1.58-.446v.242z",
    fill: "gray"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M19.216 20.072a.807.807 0 0 0-.562-.295l-3.502-.266h-3.938l-3.502.266a.801.801 0 0 0-.701 1.052l.256.776h2.552l.977 1.1a.769.769 0 0 0 .574.258h3.628c.22 0 .428-.094.574-.258l.977-1.1h2.552l.256-.776a.8.8 0 0 0-.139-.758h-.002zm-8.486 1.124a.187.187 0 0 1-.3.15l-.909-.688v-.405c0-.087.07-.157.157-.157h.895c.087 0 .157.07.157.157v.943zm4.23.859c0 .18-.146.327-.327.327h-2.901a.327.327 0 0 1-.327-.327v-1.633c0-.18.146-.326.327-.326h2.901c.18 0 .327.145.327.326v1.633zm1.884-1.397-.91.687a.187.187 0 0 1-.3-.149v-.944c0-.086.07-.156.157-.156h.896c.086 0 .157.07.157.157v.405z",
    fill: "gray"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M8.735 20.855h-.834a.168.168 0 0 0-.169.168v.835c0 .093.076.168.169.168h.834a.168.168 0 0 0 .169-.168v-.835a.168.168 0 0 0-.169-.168zM18.466 20.855h-.835a.168.168 0 0 0-.168.168v.835c0 .093.075.168.168.168h.835a.168.168 0 0 0 .168-.168v-.835a.168.168 0 0 0-.168-.168z",
    fill: "orange"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M81.786 19.921h-9.207l-4.14-1.337h17.487l-4.14 1.337z",
    fill: "#666"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M81.786 19.921h-9.207l-4.14-1.337h17.487l-4.14 1.337z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.786 19.655h-9.207l-4.14-1.338h17.487l-4.14 1.338z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M80.056 17.01H74.31v2.693h5.746V17.01z",
    fill: "#1A1A1A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M81.42 19.434h-8.474a.777.777 0 0 0-.777.777v.937c0 .43.348.777.777.777h8.473c.43 0 .777-.348.777-.777v-.937a.777.777 0 0 0-.777-.777z",
    fill: "#333"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M73.31 23.833a2.59 2.59 0 1 0-1.983-4.787 2.59 2.59 0 0 0 1.983 4.787z",
    fill: "gray"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M74.64 21.986a2.387 2.387 0 1 0-4.646-1.097 2.387 2.387 0 0 0 4.646 1.097z",
    fill: "orange"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M73.935 21.82a1.663 1.663 0 1 0-3.237-.765 1.663 1.663 0 0 0 3.237.764z",
    fill: "#333"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M72.837 21.44a.52.52 0 1 1-1.041 0 .52.52 0 0 1 1.041 0z",
    fill: "orange"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M83.881 23.27a2.59 2.59 0 1 0-3.664-3.663 2.59 2.59 0 0 0 3.664 3.664z",
    fill: "gray"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M83.737 23.127a2.387 2.387 0 1 0-3.375-3.376 2.387 2.387 0 0 0 3.376 3.376z",
    fill: "orange"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M83.69 21.707a1.663 1.663 0 1 0-3.283-.533 1.663 1.663 0 0 0 3.283.533z",
    fill: "#333"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M82.57 21.44a.52.52 0 1 1-1.042 0 .52.52 0 0 1 1.042 0zM77.103 20.925h-1.58v.24h1.58v-.24zM77.103 21.358h-1.58v.24h1.58v-.24zM77.103 20.495h-1.58v.24h1.58v-.24z",
    fill: "orange"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m77.103 20.735-1.58.445v-.24l1.58-.445v.24z",
    fill: "gray"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M77.103 21.79h-1.58v.24h1.58v-.24zM77.103 22.23h-1.58v.24h1.58v-.24z",
    fill: "orange"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m77.103 21.167-1.58.444v-.24l1.58-.446v.242zM77.103 21.598l-1.58.446v-.242l1.58-.444v.24zM77.103 22.03l-1.58.445v-.24l1.58-.446v.24z",
    fill: "gray"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M77.103 20.062h-1.58v.24h1.58v-.24z",
    fill: "orange"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m77.103 20.304-1.58.444v-.24l1.58-.446v.242z",
    fill: "gray"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M78.841 20.925h-1.58v.24h1.58v-.24zM78.841 21.358h-1.58v.24h1.58v-.24zM78.841 20.495h-1.58v.24h1.58v-.24z",
    fill: "orange"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m78.843 20.735-1.581.445v-.24l1.58-.445v.24z",
    fill: "gray"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M78.841 21.79h-1.58v.24h1.58v-.24zM78.841 22.23h-1.58v.24h1.58v-.24z",
    fill: "orange"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m78.843 21.167-1.581.444v-.24l1.58-.446v.242zM78.843 21.598l-1.581.446v-.242l1.58-.444v.24zM78.843 22.03l-1.581.445v-.24l1.58-.446v.24z",
    fill: "gray"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M78.841 20.062h-1.58v.24h1.58v-.24z",
    fill: "orange"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m78.843 20.304-1.581.444v-.24l1.58-.446v.242z",
    fill: "gray"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M83.216 20.072a.807.807 0 0 0-.562-.295l-3.502-.266h-3.938l-3.502.266a.8.8 0 0 0-.701 1.052l.256.776h2.552l.977 1.1a.769.769 0 0 0 .574.258h3.628c.22 0 .428-.094.574-.258l.977-1.1h2.552l.256-.776a.8.8 0 0 0-.139-.758h-.002zm-8.485 1.124a.187.187 0 0 1-.3.15l-.91-.688v-.405c0-.087.07-.157.157-.157h.895c.087 0 .158.07.158.157v.943zm4.229.859c0 .18-.146.327-.327.327h-2.901a.327.327 0 0 1-.327-.327v-1.633c0-.18.146-.326.327-.326h2.901c.18 0 .327.145.327.326v1.633zm1.884-1.397-.91.687a.187.187 0 0 1-.3-.149v-.944c0-.086.07-.156.157-.156h.896c.086 0 .157.07.157.157v.405z",
    fill: "gray"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M72.735 20.855h-.834a.168.168 0 0 0-.169.168v.835c0 .093.076.168.169.168h.834a.168.168 0 0 0 .168-.168v-.835a.168.168 0 0 0-.168-.168zM82.466 20.855h-.835a.168.168 0 0 0-.168.168v.835c0 .093.075.168.168.168h.835a.168.168 0 0 0 .168-.168v-.835a.168.168 0 0 0-.168-.168z",
    fill: "orange"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wgy4kf4joa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .03)",
    d: "M0 0h90v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrigeratedBoxcar);
export default __webpack_public_path__ + "static/media/refrigerated_boxcar.526ed12ef55ebe6202b7a2ad2b7bd7ee.svg";
export { ForwardRef as ReactComponent };